import * as React from "react";
import { forwardRef } from "react";
const MusicNotePhoneIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M15.75 1.485a3 3 0 0 1 3 3v16.5a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-.35a.75.75 0 1 1 1.5 0v.35a1.5 1.5 0 0 0 1.5 1.5h7.5a1.5 1.5 0 0 0 1.5-1.5v-16.5a1.5 1.5 0 0 0-1.5-1.5h-1.5v.75a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-.75h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.2a.75.75 0 1 1-1.5 0v-1.2a3 3 0 0 1 3-3h7.5zm-2.25 18.75a.75.75 0 1 1 0 1.5h-3a.75.75 0 1 1 0-1.5h3z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.169 6.415a.75.75 0 0 1 .956.721v8.197l-.003.055.003.06a2.21 2.21 0 0 1-2.209 2.209 2.21 2.21 0 0 1-2.208-2.209 2.21 2.21 0 0 1 2.208-2.208c.248 0 .486.042.709.117v-2.729L6 11.95v5.133l-.003.055.003.061a2.21 2.21 0 0 1-2.209 2.209 2.21 2.21 0 0 1-2.208-2.209 2.21 2.21 0 0 1 2.208-2.208c.248 0 .486.042.709.117V8.886a.75.75 0 0 1 .544-.721l6.125-1.75zM3.791 16.49a.71.71 0 0 0-.708.708.71.71 0 0 0 .708.709.71.71 0 0 0 .709-.709.71.71 0 0 0-.709-.708zm6.125-1.75a.71.71 0 0 0-.708.708.71.71 0 0 0 .708.709.71.71 0 0 0 .709-.709.71.71 0 0 0-.709-.708zM6 9.45v.941l4.625-1.321v-.941L6 9.45z"
}));
const ForwardRef = forwardRef(MusicNotePhoneIcon);
export default ForwardRef;